const productsData = [
  {
    id: 1,
    tag: "hero-product",
    tagline: "Keep the noise out, or in. You choose.",
    heroImage: "/pods/airpods-max/max.png",
    images: [
      "/pods/airpods-max/max.png",
      "/pods/airpods-max/max-5.png",
      "/pods/airpods-max/max-7.png",
    ],
    brand: "Apple",
    title: "AirPods Max",
    info: "Wireless High Fidelity Headphones",
    category: "Headphones",
    type: "Over Ear",
    connectivity: "Wireless",
    finalPrice: 59900,
    originalPrice: 65000,
    quantity: 1,
    ratings: 1234,
    rateCount: 5,
    path: "/product-details/",
  },
  {
    id: 2,
    tag: "featured-product",
    images: [
      "/pods/airpods-max/max-11.png",
      "/pods/airpods-max/max-sd.png",
      "/pods/airpods-max/max-11.png",
    ],
    brand: "Apple",
    title: "Airpods Max(Sky Blue)",
    info: "On-Ear Wireless Headphones",
    category: "Headphones",
    type: "On Ear",
    connectivity: "Wireless",
    finalPrice: 60000,
    originalPrice: 65000,
    quantity: 1,
    ratings: 1321,
    rateCount: 5,
    path: "/product-details/",
  },
  {
    id: 3,
    tag: "hero-product",
    tagline: "Noise-Canceling Magic in Every Note.",
    heroImage: "/pods/airpods-pro-2g/pro-2g-2.png",
    images: [
      "/pods/airpods-pro-2g/pro-2g.png",
      "/pods/airpods-pro-2g/pro-2g-10.png",
      "/pods/airpods-pro-2g/pro-2g-5.png",
    ],
    brand: "Apple",
    title: "Airpods Pro(2nd Gen)",
    info: "Wireless In-Ear Earbuds",
    category: "Earbuds",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: 41500,
    originalPrice: 45000,
    quantity: 1,
    ratings: 1244,
    rateCount: 5,
    path: "/product-details/",
  },
  {
    id: 4,
    images: ["/pods/case-1.png", "/pods/case-2.png", "/pods/case.png"],
    brand: "Apple",
    title: "Airpods Case",
    info: "Portable Airpod Case for your Airpods",
    category: "Cases",
    type: "In Ear",
    connectivity: "Wired",
    finalPrice: 2250,
    originalPrice: 3000,
    quantity: 1,
    ratings: 556,
    rateCount: 4,
    path: "/product-details/",
  },
  {
    id: 5,
    images: [
      "/pods/airpods-max/max-b.png",
      "/pods/airpods-max/max-b-1.png",
      "/pods/airpods-max/max-b-2.png",
    ],
    brand: "Apple",
    title: "Airpods Max(Space Gray)",
    info: "Bluetooth & Wired On-Ear Headphones",
    category: "Headphones",
    type: "On Ear",
    connectivity: "Bluetooth & Wired",
    finalPrice: 60000,
    originalPrice: 65000,
    quantity: 1,
    ratings: 1563,
    rateCount: 5,
    path: "/product-details/",
  },
  {
    id: 6,
    images: ["/pods/max-case-2.png", "/pods/max-case.png"],
    brand: "Apple",
    title: "Airpods Max Cases",
    info: "In-Ear Wireless Neckbands",
    category: "Max Cases",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: 5100,
    originalPrice: 5500,
    quantity: 1,
    ratings: 836,
    rateCount: 4,
    path: "/product-details/",
  },
  {
    id: 7,
    tag: "hero-product",
    tagline: "Re Built from the sound up.",
    heroImage: "/pods/airpods-pro/pro-2.png",
    images: [
      "/pods/airpods-pro/pro-2.png",
      "/pods/airpods-pro/pro-3.png",
      "/pods/airpods-pro/pro-4.png",
    ],
    brand: "Apple",
    title: "Airpods Pro",
    info: "Wireless Over-Ear Headphones",
    category: "Earbuds",
    type: "Over Ear",
    connectivity: "Wireless",
    finalPrice: 31000,
    originalPrice: 35000,
    quantity: 1,
    ratings: 679,
    rateCount: 4,
    path: "/product-details/",
  },
  {
    id: 8,
    tag: "featured-product",
    images: [
      "/pods/airpods-max/max-9.png",
      "/pods/airpods-max/max-10.png",
      "/pods/airpods-max/max-8.png",
    ],
    brand: "Apple ",
    title: "Airpods Max(Silver)",
    info: "Wireless Over-Ear NC Headphones",
    category: "Headphones",
    type: "Over Ear",
    connectivity: "Wireless",
    finalPrice: 60000,
    originalPrice: 65000,
    quantity: 1,
    ratings: 755,
    rateCount: 4,
    path: "/product-details/",
  },
  {
    id: 9,
    tag: "featured-product",
    images: [
      "/pods/airpods-pro-2g/pro-2g.png",
      "/pods/airpods-pro-2g/pro-2g-9.png",
      "/pods/airpods-pro-2g/pro-2g-10.png",
    ],
    brand: "Apple",
    title: "Airpods Pro(2nd Gen)",
    info: "In-Ear Wireless Neckbands",
    category: "Earbuds",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: 41500,
    originalPrice: 45000,
    quantity: 1,
    ratings: 1464,
    rateCount: 5,
    path: "/product-details/",
  },
  {
    id: 10,
    images: [
      "/pods/airpods/airpods-4.png",
      "/pods/airpods/airpods.png",
      "/pods/airpods/airpods-1.png",
    ],
    brand: "Apple",
    title: "Airpods",
    info: "In-Ear Truly Wireless Earbuds",
    category: "Earbuds",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: 21500,
    originalPrice: 25000,
    quantity: 1,
    ratings: 801,
    rateCount: 4,
    path: "/product-details/",
  },
  {
    id: 11,
    images: [
      "/pods/airpods-3g/airpods-3g-7.png",
      "/pods/airpods-3g/airpods-3g-2.png",
      "/pods/airpods-3g/airpods-3g-4.png",
    ],
    brand: "Apple",
    title: "Airpods (3rd Gen)",
    info: "Wireless In-Ear NC Headphones",
    category: "Earbuds",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: 27500,
    originalPrice: 30000,
    quantity: 1,
    ratings: 382,
    rateCount: 3,
    path: "/product-details/",
  },
  {
    id: 12,
    images: ["/pods/case-7.png", "/pods/case-6.png", "/pods/case-11.png"],
    brand: "Apple",
    title: "Airpods Customized Case",
    info: "Portable Airpod Case for your Airpods",
    category: "Cases",
    type: "In Ear",
    connectivity: "Wired",
    finalPrice: 2250,
    originalPrice: 3000,
    quantity: 1,
    ratings: 1178,
    rateCount: 5,
    path: "/product-details/",
  },
  {
    id: 13,
    tag: "featured-product",
    images: [
      "/pods/airpods-pro/pro-2.png",
      "/pods/airpods-pro/pro-3.png",
      "/pods/airpods-pro/pro-4.png",
    ],
    brand: "Apple",
    title: "Airpods Pro",
    info: "In-Ear Wired Earphones",
    category: "Earbuds",
    type: "In Ear",
    connectivity: "Wired",
    finalPrice: 31000,
    originalPrice: 35000,
    quantity: 1,
    ratings: 1144,
    rateCount: 5,
    path: "/product-details/",
  },
  {
    id: 14,
    tag: "featured-product",
    images: [
      "/pods/airpods/airpods.png",
      "/pods/airpods/airpods-4.png",
      "/pods/airpods/airpods-5.png",
    ],
    brand: "Apple",
    title: "Apple Airpods",
    info: "Wireless Freedom, Uninterrupted Tunes",
    category: "Earbuds",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: 21500,
    originalPrice: 25000,
    quantity: 1,
    ratings: 1340,
    rateCount: 5,
    path: "/product-details/",
  },
  {
    id: 15,
    images: [
      "/pods/airpods-max/max-g.png",
      "/pods/airpods-max/max-g-1.png",
      "/pods/airpods-max/max-12.png",
      ,
    ],
    brand: "Apple",
    title: "Airpods Max(Green)",
    info: "Wireless Over-Ear NC Headphones",
    category: "Headphones",
    type: "Over Ear",
    connectivity: "Wireless",
    finalPrice: 60000,
    originalPrice: 65000,
    quantity: 1,
    ratings: 853,
    rateCount: 4,
    path: "/product-details/",
  },
  // {
  //   id: 16,
  //   images: [
  //     "/images/products/jbl500bt-1.png",
  //     "/images/products/jbl500bt-2.png",
  //     "/images/products/jbl500bt-3.png",
  //     "/images/products/jbl500bt-4.png",
  //   ],
  //   brand: "JBL",
  //   title: "JBL Tune 500BT",
  //   info: "On-Ear Wireless Headphones",
  //   category: "Headphones",
  //   type: "On Ear",
  //   connectivity: "Wireless",
  //   finalPrice: 3282,
  //   originalPrice: 3999,
  //   quantity: 1,
  //   ratings: 364,
  //   rateCount: 4,
  //   path: "/product-details/",
  // },
  {
    id: 17,
    images: [
      "/pods/airpods-2g/airpods-2nd-1.png",
      "/pods/airpods-2g/airpods-2nd-2.png",
      "/pods/airpods-2g/airpods-2nd-4.png",
    ],
    brand: "Apple",
    title: "Airpods (2nd Gen)",
    info: "In-Ear Wireless Earbuds",
    category: "Earbuds",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: 21500,
    originalPrice: 25000,
    quantity: 1,
    ratings: 1011,
    rateCount: 5,
    path: "/product-details/",
  },
  {
    id: 18,
    images: ["/pods/case-10.png", "/pods/case-9.png", "/pods/case-8.png"],
    brand: "Apple",
    title: "Airpods Case(Memojis)",
    info: "Portable Airpod Case for your Airpods",
    category: "Cases",
    type: "In Ear",
    connectivity: "Wired",
    finalPrice: 3100,
    originalPrice: 3500,
    quantity: 1,
    ratings: 530,
    rateCount: 4,
    path: "/product-details/",
  },
  {
    id: 19,
    images: ["/pods/max-case.png", "/pods/max-case-2.png"],
    brand: "Apple",
    title: "Airpods Max Cases",
    info: "Wireless Extra Bass In-Ear Neckbands",
    category: "Max Cases",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: 5100,
    originalPrice: 5500,
    quantity: 1,
    ratings: 474,
    rateCount: 4,
    path: "/product-details/",
  },
  // {
  //   id: 20,
  //   image: ["/pods/airpods-banner.jpeg"],
  //   category: "banner",
  // },
  // {
  //   id: 21,
  //   image: ["/pods/airpods-max.jpeg"],
  //   category: "banner",
  // },
];

export default productsData;
